import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Container from "@mui/material/Container";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TaskmgmtServiceURL } from "../../../config/config";
import {
  DataGridPro,
  GridActionsCellItem,
  GridToolbarFilterButton,
  GridPaginationModel,
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
  getGridStringOperators,
  GridLogicOperator,
} from "@mui/x-data-grid-pro";
import { DataGrid } from "../../util/DataGrid";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import { GridFilterModel } from "@mui/x-data-grid";
import { ServiceName } from "../../../constants";
import { useResizeDetector } from "react-resize-detector";


interface filter {
  "identity": string
  "matchMode": string,
  "value": string
}

export const FundConfigurationDashboard = () => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };



  const [fundConfig, setFundConfig] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: pageSize,
  });
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    logicOperator:GridLogicOperator.And
  });

  const [filterFundConfig, setFilterFundConfig] = React.useState<filter[]>([]);
  const [rowCount, setRowCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const { width,ref } = useResizeDetector();
  const [columnWidths,setColumnWidths] = useState<any>({});

  useEffect(()=>{
    if(width){
      const newColumnWidths = {
        column1:width * 0.1,
        column2:width * 0.15
      };
      setColumnWidths(newColumnWidths);
    }
  },[width]);
  const formatNumber = (params:any) => {
    if(params.value !== null)
      return<div style={{textAlign:'right',width:'85%',paddingRight:'5px'}}>
        {params.value.toLocaleString('en-US')}
      </div>
     ;
  }

  const fetchData = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    setLoading(true);
    await GetFundConfig(paginationModel, filterModel).then(
      (data: any) => {
        setFundConfig(data?.result?.fundConfig);
        setRowCount(data.result.rowCount);
      }
    ).catch((e) => {
      console.log(e);

    }).finally(() => { setLoading(false) });
  };

  const GetFundConfig = async (paginationModel: GridPaginationModel, filterModel: GridFilterModel) => {
    var fundConfigArr: any[] = [];
    fundConfigArr = filterModel?.items?.map((fundConfigFilter: any) => {
      if (fundConfigFilter?.value != undefined) {
        return {
          identity: fundConfigFilter?.field,
          matchMode: fundConfigFilter?.operator,
          value: fundConfigFilter?.value,
        };
      }
    });
    console.log(fundConfigArr);
    var url = TaskmgmtServiceURL + "/FundConfigurations/GetAllFundConfigDashboard";
    var payload = {
      filters: fundConfigArr,
      first: paginationModel.pageSize * paginationModel.page,
      filterConditionalOperator: filterModel.logicOperator,
      globalFilter: null,
      rows: paginationModel.pageSize,
      sortOrder: 1
    };

    if(payload.filters.length == 0){
      payload = {...payload,filterConditionalOperator:GridLogicOperator.And}
    }
    const response = postApiCall(url, payload, ServiceName.TASKMANAGEMENTSERVICE).then((data: any) => data);
    return response;
  };

  useEffect(() => {
    fetchData(paginationModel, filterModel);
  }, [paginationModel, filterModel]);

  const columns: GridColDef[] = [
    {
      field: "action",
      headerName: "Actions",
      sortable: false,
      filterable: false,
      disableExport: true,
      renderCell: (cellValues) => {
        const onEditClick = (e: any) => {
          e.stopPropagation();
          navigate("/fundconfig/" + "edit/" + cellValues.id);
        };

        const onViewClick = (e: any) => {
          e.stopPropagation();
          navigate("/fundconfig/" + "view/" + cellValues.id);
        };
        return (
          <>
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<VisibilityIcon />}
              label="View"
              onClick={(event) => {
                onViewClick(event);
              }}
            />
            <GridActionsCellItem
              sx={{
                color: "#253746",
              }}
              icon={<EditIcon />}
              label="Edit"
              onClick={(event) => {
                onEditClick(event);
              }}
            />
          </>
        );
      },
      width:columnWidths.column2 || 100,
    },
    { field: "fundName", headerName: "Fund", width:columnWidths.column2 || 100,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "investmentType", headerName: "Investment Type", width:columnWidths.column2 || 100,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
    { field: "appraisalSchedule", headerName: "Schedule", width:columnWidths.column2 || 100 ,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    ) },
    { field: "delayPosting", headerName: "Delay Posting", width:columnWidths.column2 || 100 ,
    
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    ) },
    { field: "scheduleDayAppraisal", headerName: "Schedule Day", width:columnWidths.column2 || 100 ,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    ) },
    { field: "region", headerName: "Region", width:columnWidths.column2 || 100,
    filterOperators: getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    )  },
  ];

  const handelPaginationModel = (e: GridPaginationModel) => {
    setPaginationModel(e);
    fetchData(e, filterModel);

  };

  const handelFilterModelChange = (model: any) => {
    // const count = model?.items.length != 0 ? Object.keys(model?.items[0]).length-1 : 0;
    // if (count === 4) {
    setFilterModel(model);
    fetchData(paginationModel, model);
    // }
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
        <GridToolbarFilterButton />
      </GridToolbarContainer>
    );
  };


  return (
    <Container maxWidth={false} className="dashboard-wrap">
      <Stack direction="row" spacing={2} className="user-role-action-btn">

        <div></div>
      </Stack>

      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Button sx={{textTransform:"none"}}
              className="head-action-btn text-right"
              variant="contained"
              color="success"
              onClick={() => navigate("/fundconfig/new")}
            >
              <AddIcon />
              New Fund Configuration
            </Button>
            <TabList
              onChange={handleChange}
              aria-label="Appraisals Tab"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="All Items" value="1" sx={{textTransform:'capitalize'}} />
            </TabList>
          </Box>
          <TabPanel ref={ref} data-testid='fundGrid' value="1">
            {
              <DataGrid data-testId='datagridfund'
                rows={fundConfig}
                rowCount={rowCount}
                columns={columns}
                paginationModel={paginationModel}
                PaginationModelChange={handelPaginationModel}
                filterModel={filterModel}
                loading={loading}
                filterModelChange={(model: GridFilterModel) => handelFilterModelChange(model)}
                customToolbar={CustomToolbar}
              />
            }
          </TabPanel>
        </TabContext>
      </Box>
    </Container>
  );
};


